export default __webpack_public_path__ + "static/media/zeit.cbc8eb75.svg";